import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../Common/Icon';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../../constants/constants';
import { TruncateText } from '../../../../helpers/strings';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import './ListViewMobile.scss';

const ListViewMobile = ({ locationTasks, totalCount, filters, onSelectTask, isFetchingTasks }) => {

    let rowNum = 0;

    const findRowNum = () => {
        rowNum++;
        return rowNum;
    }

    const findIsCompleted = (steps) => {
        if (steps) {
            const completed = steps.filter(m => m.isCompleted);
            if (completed) {
                return completed.length;
            }
        }
        return 0;
    }

    const findTargetClassName = (task) => {
        if (task.targetDate) {
            const targetDate = Moment.utc(task.targetDate);

            if (task.coreStatusName === "Complete" || task.coreStatusName === "Not Applicable") {
                return "text-success";
            } else if (Moment().isAfter(targetDate.add(1, 'days'))) {
                return "text-danger";
            }
        }
        return "";
    }

    return (
        <div className="mt-2 location-mobile-task-list">
            <LoadingIndicator isLoading={isFetchingTasks} >
                <div>
                    {
                        locationTasks.map(task =>
                            <div key={task.id} onClick={() => onSelectTask(task)} className={(findRowNum() % 2 == 0) ? "alt-color p-2" : "bg-white p-2"}>
                                <div className="pb-1">
                                    {task.isMilestone ?
                                        <span className="text-warning me-3">&#x25C6;</span>
                                        :
                                        null
                                    }
                                    <span className="me-2"><Icon name="calendar-alt" /></span>
                                    {filters.isStartDateActive && task.startDate ?
                                        <span>{Moment.utc(task.startDate).format(DATE_FORMAT)} - </span>
                                        :
                                        null
                                    }
                                    <span className={findTargetClassName(task)}>{Moment.utc(task.targetDate).format(DATE_FORMAT)}</span>
                                    <span className="ms-3 me-2"><Icon name="user" /></span>
                                    {task.responsibleUserName ?

                                        <span>{task.responsibleUserName}</span>
                                        :
                                        <span>{task.jobTitleName}</span>
                                    }
                                </div>
                                <div className="pb-1">
                                    <span className="description">{task.name}</span>
                                </div>
                                <div>
                                    {filters.isProjectWidgetActive && task.projectName ?
                                        <span className="me-1">{TruncateText(task.projectName, 45)}</span>
                                        :
                                        null
                                    }
                                    {task.statusName}
                                    {filters.isTaskStepsActive && task.steps && task.steps.length > 0 ?
                                        <span className="ms-2"><span className="me-1"><strong>Steps:</strong></span>{findIsCompleted(task.steps)}/{task.steps.length} done</span>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
                <hr />
                <div className="text-center">
                    <strong>Total Count: </strong>{totalCount}
                </div>

            </LoadingIndicator>

        </div>
    );
};

ListViewMobile.propTypes = {
    locationTasks: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    filters: PropTypes.object.isRequired,
    onSelectTask: PropTypes.func.isRequired,
    isFetchingTasks: PropTypes.bool.isRequired,
    columnFilters: PropTypes.object.isRequired,
    searchParams: PropTypes.object.isRequired,
    updateSearchParams: PropTypes.func.isRequired,
    locationTaskActions: PropTypes.object.isRequired,
}

export default ListViewMobile;